import React, { useCallback } from 'react';
import { SharpGlyph, FlatGlyph } from 'types/enums';
import { KeyRootApi } from 'types/generated/graphql';
import { Box, ToggleButton, Text } from '@landr/maestro';
import {
    toggleGridStyles,
    toggleContainerStyles,
    toggleTextStyles,
    toggleButtonStylesV3,
    toggleDiagonalLineStylesV3,
} from './styled';

export const KeyToggle: React.FC<{
    value: KeyRootApi;
    notes: [KeyRootApi] | [KeyRootApi, KeyRootApi];
    isSelected: boolean;
    onChange: (value: KeyRootApi) => void;
    isMobile: boolean;
}> = ({ value, notes, isSelected, onChange, isMobile }) => {
    const [sharp, flat] = notes;
    const handleOnChange = useCallback(() => {
        onChange(value);
    }, [value, onChange]);

    if (!flat) {
        return (
            <ToggleButton
                className={toggleButtonStylesV3}
                size={isMobile ? 'md' : 'sm'}
                width={isMobile ? 'md' : 'sm'}
                height={isMobile ? 'md' : 'sm'}
                justifyContent="center"
                alignItems="center"
                value={value}
                isSelected={isSelected}
                onChange={handleOnChange}
                cursor="pointer"
            >
                <Text as="p" className={toggleTextStyles} fontSize="md">
                    {sharp}
                </Text>
            </ToggleButton>
        );
    } else {
        return (
            <ToggleButton
                className={toggleButtonStylesV3}
                size={isMobile ? 'md' : 'sm'}
                value={value}
                isSelected={isSelected}
                onChange={handleOnChange}
                cursor="pointer"
            >
                <Box className={toggleContainerStyles}>
                    <Box className={toggleGridStyles}>
                        <Text
                            as="p"
                            display="block"
                            lineHeight="18px"
                            minWidth="16px"
                            margin="unset"
                            gridColumn="1"
                            gridRow="1"
                            transform={{
                                base: isMobile
                                    ? 'translate(8px, 2px)'
                                    : 'translate(2px, 2px)',
                                md: 'translate(4px,2px)',
                            }}
                            fontSize={isMobile ? 'md' : 'sm'}
                        >
                            {sharp}
                            <sup>{SharpGlyph}</sup>
                        </Text>
                        <Box
                            className={toggleDiagonalLineStylesV3}
                            as="span"
                            width={{
                                base: isMobile ? 'md' : 'sm',
                                md: 'sm',
                            }}
                        />
                        <Text
                            as="p"
                            display="block"
                            lineHeight="18px"
                            margin="unset"
                            gridColumn="2"
                            gridRow="2"
                            transform={{
                                base: isMobile
                                    ? 'translate(8px, -2px)'
                                    : 'translate(-2px, -2px)',
                                md: 'translate(0px,-2px)',
                            }}
                            fontSize={isMobile ? 'md' : 'sm'}
                        >
                            {flat}
                            <sup>{FlatGlyph} </sup>
                        </Text>
                    </Box>
                </Box>
            </ToggleButton>
        );
    }
};
